import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import swal from 'sweetalert';
import { useGetPaginatedSytemsRegionsQuery, useGetSystemRegionsPageChangeMutation } from '../../Features/regionSlice';
import { PlusIcon } from '@heroicons/react/solid';
import LoadingBar from 'react-top-loading-bar';
import { useIsOnline } from 'react-use-is-online';
import ReactPaginate from 'react-paginate';
import '../../Pagination.css';


function ManageRegionView({}) {
    const navigate = useNavigate();
    const [pager, setPager] = useState("")
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();
    const [numRowsPerPage, setNumRowsPerPage] = useState(10)
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);

    const {
      data: regions,
      isLoading,
      isSuccess,
      isError,
      error
    } = useGetPaginatedSytemsRegionsQuery({paginate: numRowsPerPage, page: pager})

    const [input, setInput] = useState({
      search: ''
    })

    useEffect(()=>{
    setProgress(30)
        if(isLoading){
            setProgress(80)
        }
        if(isSuccess && !currentItems.length > 0){
          setCurrentItems(regions.data.data);
          setPageCount(Math.ceil(regions.data.total / numRowsPerPage));
        }
        setProgress(100)
        return () =>{
        }
    },[regions])

    const [pageChange] = useGetSystemRegionsPageChangeMutation();

    const onChangePageRows = async(rows) => {
      let rowsPerPage = window.parseInt(rows)
      if(!isOnline){
        return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        try {
          setProgress(80)
          const resp = await pageChange({paginate: rowsPerPage, page: 1}).unwrap();
          setCurrentItems(resp.data.data);
          if(resp.success){
              setPageCount(Math.ceil(resp.data.total / resp.data.data.length));
              setNumRowsPerPage(rowsPerPage)
              setProgress(100)
            }
        } catch (err) {
            setProgress(100)
            swal("Error",err.message,'error');
        }
    }
  
    const handlePageChange = async(currentPage) => {
      let pageNum = window.parseInt(currentPage) + 1
      if(!isOnline){
        return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        try {
          setProgress(80)
          const resp = await pageChange({paginate: numRowsPerPage, page: pageNum}).unwrap();
          if(resp.success){
            setCurrentItems(resp.data.data);
            setPageCount(Math.ceil(resp.data.total / numRowsPerPage));
            setProgress(100)
            }
        } catch (err) {
            setProgress(100)
            swal("Error",err.message,'error');
        }
    };

  const editRegion = (e, id)=>{
    if(!isOnline){
      return swal("No Internet connection",'Please check Internet connection and try again'); 
    }
    navigate("/user/edit-region/"+id)
  }

    const trancateText = (str)=>{
      return str.length > 25 ? str.substring(0, 25) + "..." : str;
    }
    
    return (
      <div className="flex md:w-2/4 mb-12">
        <LoadingBar
        color="#14b8a6"
        height="4px"
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
        />
      <div className='bg-white shadow-md rounded-md'>
        {(isSuccess)?
          <div className="md:flex items-center md:justify-between px-4 py-6 space-y-4">
            <Link to='/user/add-region' className='flex items-center text-sm text-white justify-center bg-green-400 px-3 py-2 rounded-sm hover:shadow-md cursor-pointer'>
              <PlusIcon className='h-4 w-4'></PlusIcon>
              <div className=''>ADD REGION</div>
            </Link>
          </div>
          : null
        }
        {
              (currentItems.length > 0)?
                <table className="table-fixed w-full divide-y divide-gray-100">
                  <thead className="text-xs text-gray-500">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left font-medium tracking-wider"
                      >
                        Region
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left font-medium tracking-wider"
                      >
                        Description
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    { currentItems.map(data => (
                      <tr onClick={(e)=>editRegion(e,data.id)} key={data.id} className="hover:bg-gray-50 cursor-pointer text-gray-700 text-xs">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="">
                                <div className="flex items-center">
                                    <div className="">{trancateText(data.name)}</div>
                                </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="">{trancateText(data.description)}</div>
                        </td>
                      </tr>
                    ))
                }
                  </tbody>
                </table>
              : isError?
                 <Link to='/user/add-region' className='flex items-center text-sm text-white justify-center bg-green-400 px-3 py-2 rounded-sm hover:shadow-md cursor-pointer'>
                  <PlusIcon className='h-4 w-4'></PlusIcon>
                  <div className=''>ADD REGION</div>
                </Link>
              : null
            }
            {(currentItems.length > 0)?                  
              <div className="flex items-center justify-start px-2 space-x-8 mt-3 mb-10 border-t border-gray-100">
                    <ReactPaginate
                    breakLabel="..."
                    nextLabel={<ChevronRightIcon className='h-8 text-gray-400 bg-white cursor-pointer hover:bg-gray-50' />}
                    onPageChange={(e)=> handlePageChange(e.selected)}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    previousLabel={<ChevronLeftIcon className='h-8 text-gray-400 bg-white cursor-pointer hover:bg-gray-50' />}
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='controlBtn'
                    nextLinkClassName='controlBtn'
                    activeLinkClassName='active'
                  />
                  <form className="">
                    <div className="relative flex items-center text-gray-400 focus-within:text-gray-600">
                      <div className='text-gray-500 px-2 text-xs'>Rows per page</div>
                      <select onChange={(e) => onChangePageRows(e.target.value)} className='hover:bg-gray-50 outline transition m-0 ease-in-out bg-white text-gray-500 w-20 p-1 outline-none border-b border-gray-200'>
                        <option value='10' className='text-gray-800 text-sm'>10</option>
                        <option value='25' className='text-gray-800 text-sm'>25</option>
                        <option value='50' className='text-gray-800 text-sm'>50</option>
                        <option value='100' className='text-gray-800 text-sm'>100</option>
                      </select>
                    </div>
                  </form>
              </div>
              : null
            }
        </div>
      </div>
    )
}

export default ManageRegionView;
